import { useEffect } from 'react';
import { useGetExportStatus } from 'hooks/exportResultAsync';
import type { ExportStatus } from 'types/result';
import { ExportStatusValue } from 'types/result';

export function ExportStatusUpdater({
  resultId,
  currentStatus,
  onUpdate,
}: {
  resultId: number;
  currentStatus?: ExportStatusValue;
  onUpdate: (updatedStatus: ExportStatus) => void;
}) {
  const isUnfinished =
    currentStatus === undefined ||
    currentStatus === ExportStatusValue.NoStatus ||
    currentStatus === ExportStatusValue.Pending ||
    currentStatus === ExportStatusValue.Progress ||
    currentStatus === ExportStatusValue.Retry;

  const { data: updatedStatus } = useGetExportStatus(resultId, {
    enabled: isUnfinished,
  });

  useEffect(() => {
    if (updatedStatus && updatedStatus.status !== currentStatus) {
      onUpdate(updatedStatus);
    }
  }, [updatedStatus, currentStatus, onUpdate]);

  return null;
}
